import React, { useMemo } from 'react'
import { Box } from 'ui/acro'
import { Flex, P, Tag } from 'ui/bend'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import moment from 'moment'

const Item = styled(Box)(
  css({
    padding: ['8px 12px', '8px 20px', '4px 40px'],
    textAlign: 'center',
    flexBasis: ['50%', '50%', 'auto']
  })
)

const SummaryBannerFlex = styled(Flex)`
  display: grid;
  margin-top: 16px;
  margin: 0 auto;
  width: fit-content;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }

  .row-item {
    margin: 0 auto;
    width: fit-content;
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(3, 1fr);
  }
  .second-row {
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
  }
`

const ItemTitle = styled(Tag)((props) =>
  css({
    fontWeight: '500',
    fontSize: [16, 16, 18],
    lineHeight: ['135%', '24px'],
    letterSpacing: ['0.8px', '0.9px'],
    textAlign: 'center',
    fontFamily: props.theme.fonts.Proxima
  })
)

const ItemValue = styled(P)(
  css({
    fontWeight: '400',
    fontSize: [28, 28, 32],
    letterSpacing: '0.12em',
    lineHeight: '130%',
    textAlign: 'center'
  })
)

const SummaryBanner = ({ summary }) => {
  const totalTime = useMemo(() => {
    if (!summary?.totalTime) {
      return '00:00'
    }
    const duration = moment.duration(Number(summary.totalTime), 'seconds')

    const hours = Math.floor(duration.asHours())
    const formatted =
      `${hours > 0 ? `${hours}:` : ''}` +
      String(duration.minutes()).padStart(2, '0') +
      ':' +
      String(duration.seconds()).padStart(2, '0')
    return formatted
  }, [summary])

  return (
    <SummaryBannerFlex>
      <div className='row-item first-row'>
        <Item>
          <ItemTitle>Week Streak</ItemTitle>
          <ItemValue>
            {summary?.weekStreak ? summary.weekStreak : '0'}
          </ItemValue>
        </Item>
        <Item>
          <ItemTitle>Active Days</ItemTitle>
          <ItemValue>
            {summary?.activeDays ? summary.activeDays : '0'}
          </ItemValue>
        </Item>
        <Item>
          <ItemTitle>Total Time</ItemTitle>
          <ItemValue>{totalTime}</ItemValue>
        </Item>
      </div>
      <div className='row-item second-row'>
        <Item>
          <ItemTitle>Classes</ItemTitle>
          <ItemValue>
            {summary?.numberOfClasses ? summary.numberOfClasses : '0'}
          </ItemValue>
        </Item>
        <Item>
          <ItemTitle>Programs</ItemTitle>
          <ItemValue>
            {summary?.numberOfPrograms ? summary.numberOfPrograms : '0'}
          </ItemValue>
        </Item>
      </div>
    </SummaryBannerFlex>
  )
}

export default SummaryBanner
